/* Ongléa product-page kit — sticky CTA, every link to the offer, de-JS'd widgets. */
(function () {
  'use strict';
  var OFFER = '#og-offer';

  /* Prefer the real tier block. The #og-offer anchor sits inside the theme's
     position:sticky info column, so its measured offset tracks the viewport
     and scrolling to it is a no-op. */
  function offerEl() {
    /* the Lumin tier cards are hidden now that the packs are drawn by the
       stem-cell picker, and a display:none element measures as 0 — scrolling
       to it landed nowhere. Aim at the visible pack strip first. */
    return document.querySelector('.ogpo__tiers') ||
           document.querySelector('.ogpo') ||
           document.querySelector('.lumin-product-block-qty-break') ||
           document.querySelector(OFFER);
  }

  /* the theme's header is sticky; landing the offer at a fixed 90px put the
     pack strip underneath it. Measure the header that is actually pinned. */
  function headerOffset() {
    /* the pinned element is the inner .header (sticky), sitting below a sticky
       announcement bar — the section wrapper itself is position:relative, so
       measuring the wrapper reports no offset at all. Take the lowest edge of
       anything actually pinned near the top. */
    var max = 0;
    document.querySelectorAll(
      'header, .header, sticky-header, .header-wrapper, .announcement-bar, ' +
      '[class*="announcement"]'
    ).forEach(function (e) {
      var c = getComputedStyle(e);
      if (c.position !== 'fixed' && c.position !== 'sticky') return;
      var b = e.getBoundingClientRect();
      if (b.height && b.bottom > max && b.bottom < window.innerHeight / 2) max = b.bottom;
    });
    /* +10 again for the ECONOMISEZ pills, which overhang the cards upward */
    return Math.round(max) + 28;
  }

  /* The offer is the whole buy block: scent picker -> pack strip -> add button.
     Aiming at the pack strip alone left the picker scrolled off the top, so the
     customer landed on the packs with nothing to choose from. Frame the lot. */
  function offerBounds() {
    var head = document.querySelector('.ogpo') ||
               document.querySelector('.lumin-product-block-qty-break') ||
               document.querySelector(OFFER);
    if (!head) return null;
    var btn = document.querySelector('.product-form__buttons') ||
              document.querySelector('button[name="add"]');
    var hr = head.getBoundingClientRect();
    var top = hr.top + window.pageYOffset;
    var bottom = btn ? (btn.getBoundingClientRect().bottom + window.pageYOffset)
                     : (hr.bottom + window.pageYOffset);
    return { top: top, bottom: bottom };
  }

  function offerTarget() {
    var b = offerBounds();
    if (!b) return null;
    var head = headerOffset();
    var space = window.innerHeight - head;
    var h = b.bottom - b.top;
    /* fits on screen: centre it in the space under the header */
    if (h < space) return Math.round(b.top - head - Math.max(0, (space - h) / 2));
    return Math.round(b.top - head);
  }

  function scrollToOffer(e) {
    var y = offerTarget();
    if (y === null) return;
    if (e) e.preventDefault();
    y = Math.max(0, y);
    try { window.scrollTo({ top: y, behavior: 'smooth' }); } catch (x) { window.scrollTo(0, y); }
    /* two correction passes: the sticky info column shifts the target as we go */
    [420, 700].forEach(function (d) {
      setTimeout(function () {
        var r = offerTarget();
        if (r === null) return;
        r = Math.max(0, r);
        if (Math.abs(window.pageYOffset - r) > 6) window.scrollTo(0, r);
        /* make the sticky bar re-evaluate: a programmatic scroll does not
           always emit a scroll event in embedded webviews */
        window.dispatchEvent(new Event('scroll'));
      }, d);
    });
    setTimeout(function () {
      var first = document.querySelector('.lumin-product-block-qty-break input[type="radio"]');
      if (first) first.focus({ preventScroll: true });
    }, 420);
  }

  /* every CTA inside the cloned sections goes to the offer — never off-site.
     The buy box is included: the theme's "Afficher tous les détails" link
     pointed back at the product URL and reloaded the page. */
  function wire() {
    document.querySelectorAll(
      '.og a[href], #og-sticky a, .product__view-details, ' +
      '.product__info-container a[href]'
    ).forEach(function (a) {
      if (a.classList.contains('skip-to-content-link')) return;
      if (a.closest('.ogpo')) return;
      var h = a.getAttribute('href') || '';
      if (/^(mailto:|tel:)/i.test(h)) return;
      if (a.closest('summary, details > summary')) return;
      a.setAttribute('href', OFFER);
      if (!a.dataset.nxWired) {
        a.dataset.nxWired = '1';
        a.addEventListener('click', scrollToOffer);
      }
    });
    /* buttons / divs the clone left as JS triggers */
    document.querySelectorAll('.og button:not([type="submit"]), .og [role="button"]').forEach(function (b) {
      if (b.closest('summary, details, .jm-review-widget__sort, select')) return;
      if (b.dataset.nxWired) return;
      b.dataset.nxWired = '1';
      b.addEventListener('click', scrollToOffer);
    });
  }

  /* the clone keeps scroll-reveal classes but not the observer that clears them */
  function reveals() {
    document.querySelectorAll('.og .scroll-trigger, .og [class*="animate--"], .og .fade-out')
      .forEach(function (e) {
        e.classList.remove('scroll-trigger');
        e.style.opacity = '1';
        e.style.transform = 'none';
        e.style.visibility = 'visible';
      });
  }

  /* <details> already work natively; make sure none are stuck closed by CSS */
  function accordions() {
    document.querySelectorAll('.og details > summary').forEach(function (s) {
      s.style.cursor = 'pointer';
      s.style.listStyle = 'none';
    });
  }

  /* Keep the bar a direct child of <body>: any ancestor with a transform /
     filter / contain turns position:fixed into position:absolute and the bar
     drifts off-screen (it had been swallowed into a cloned section). */
  function hoist(bar) {
    if (bar.parentElement !== document.body) document.body.appendChild(bar);
  }

  function sticky() {
    var bar = document.getElementById('og-sticky');
    if (!bar) return;
    hoist(bar);
    var link = bar.querySelector('a');
    if (link && !link.dataset.nxWired) {
      link.dataset.nxWired = '1';
      link.addEventListener('click', scrollToOffer);
    }
    function tick() {
      /* only once the whole offer block has scrolled off the top, and never
         while the real Add-to-cart button is still on screen */
      var t = offerEl();
      var show = false;
      if (t) show = t.getBoundingClientRect().bottom < 0;
      /* never over the cart: the drawer's own checkout button must stay tappable */
      if (show && document.querySelector(
            'cart-drawer.active, cart-drawer.is-open, #CartDrawer.active, .cart-drawer.active, ' +
            'cart-drawer[open], dialog[open] #CartDrawer')) show = false;
      var buy = document.querySelector('.product-form__buttons');
      if (show && buy) {
        var b = buy.getBoundingClientRect();
        if (b.bottom > 0 && b.top < window.innerHeight) show = false;
      }
      bar.style.visibility = show ? 'visible' : 'hidden';
      bar.style.opacity = show ? '1' : '0';
      bar.style.pointerEvents = show ? 'auto' : 'none';
    }
    tick();
    window.addEventListener('scroll', tick, { passive: true });
    window.addEventListener('resize', tick);
  }

  /* the video rail under the guarantee card: arrows scroll it one card at a
     time and a tap opens the clip full size, with sound. */
  function videos() {
    var box = document.querySelector('.ogvid');
    if (!box || box.dataset.ogWired === '1') return;
    box.dataset.ogWired = '1';
    var rail = box.querySelector('[data-ogvid-rail]');
    var lb = box.querySelector('[data-ogvid-lb]');
    var big = lb.querySelector('video');
    var cards = [].slice.call(rail.querySelectorAll('.ogvid__c'));
    var step = 105 + 16;

    function arrows() {
      var max = rail.scrollWidth - rail.clientWidth - 2;
      box.querySelector('[data-ogvid="-1"]').hidden = rail.scrollLeft <= 2;
      box.querySelector('[data-ogvid="1"]').hidden = rail.scrollLeft >= max;
    }
    rail.addEventListener('scroll', arrows, { passive: true });
    window.addEventListener('resize', arrows);
    arrows();

    box.querySelectorAll('[data-ogvid]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var from = rail.scrollLeft;
        var to = from + (+b.dataset.ogvid) * step * 2;
        try { rail.scrollTo({ left: to, behavior: 'smooth' }); } catch (x) { rail.scrollLeft = to; }
        /* some embedded webviews never run the smooth animation — jump instead */
        setTimeout(function () { if (rail.scrollLeft === from) rail.scrollLeft = to; arrows(); }, 350);
      });
    });

    function close() {
      lb.classList.remove('is-open');
      big.pause();
      big.removeAttribute('src');
      big.load();
      document.documentElement.style.overflow = '';
    }
    cards.forEach(function (c) {
      c.addEventListener('click', function (e) {
        e.preventDefault();
        var src = c.querySelector('video').getAttribute('src');
        big.setAttribute('src', src);
        big.muted = false;
        lb.classList.add('is-open');
        document.documentElement.style.overflow = 'hidden';
        var pr = big.play();
        if (pr && pr.catch) pr.catch(function () {});
      });
    });
    lb.addEventListener('click', function (e) {
      if (e.target === lb || e.target.closest('[data-ogvid-close]')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && lb.classList.contains('is-open')) close();
    });

    /* iOS refuses autoplay until the element is in view and muted is set as a
       property, not just an attribute */
    rail.querySelectorAll('video').forEach(function (v) {
      v.muted = true;
      var pr = v.play();
      if (pr && pr.catch) pr.catch(function () {});
    });
  }

  /* One delegated handler instead of per-node wiring: the sticky bar and the
     cloned sections are both re-rendered by the theme, and a re-rendered <a>
     lost its listener and fell through to the native hash jump — which lands
     on the anchor inside the sticky column and scrolls nowhere useful. */
  function delegate() {
    if (document.documentElement.dataset.ogDelegated === '1') return;
    document.documentElement.dataset.ogDelegated = '1';
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href="' + OFFER + '"]');
      if (!a) return;
      scrollToOffer(e);
    }, true);
  }

  function init() {
    delegate(); reveals(); accordions(); wire(); sticky(); videos();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('load', reveals);
})();

/* ── Sélecteur de cellules souches ────────────────────────────────────────
   Reproduit le « Choose your stem cells » du concurrent : une seule liste
   avec vignette, nom, bénéfice et compteur +/-, au-dessus des packs.
   Les <select> natifs de Lumin restent la source de vérité (un article de
   panier par stylo) — ils sont simplement masqués et pilotés d'ici.        */
(function () {
  'use strict';

  var ACC = '#C4456B', INK = '#121212', MUTED = '#6F6862',
      BORDER = '#E4DFDA', SOFT = '#FAF6F3';

  var CELLS = [
    { v: 'Échinacée pourpre', sub: 'Réparation & croissance',  img: 'og_cell1.png', badge: 'Le plus choisi' },
    { v: 'Rose de Damas',     sub: 'Hydratation & apaisement', img: 'og_cell2.png' },
    { v: 'Pomme suisse',      sub: 'Anti-âge & solidité',      img: 'og_cell3.png' },
    { v: 'Jasmin',            sub: 'Protection antioxydante',  img: 'og_cell4.png' }
  ];

  var CSS = [
    /* the stacked Lumin cards are replaced by the source's 3-up strip */
    'html body .lumin-product-block-qty-break{display:none!important;}',
    '.lumin-product-block-qty-break-variants{display:none!important;}',
    '.lumin-form-select{background-size:11px auto!important;}',
    /* the source's whole buy column is 345px wide, so its chooser and packs
       are that narrow too. Ours sits in a 541px column — cap the panel. */
    '.ogpo{margin:0 0 18px;}',
    '.ogpo__head{display:flex;align-items:baseline;justify-content:space-between;gap:12px;margin:0 0 6px;}',
    '.ogpo__title{font:400 22px/26.4px Asul,Georgia,serif;color:' + INK + ';margin:0;}',
    '.ogpo__rem{font:400 15px/21.75px Karla,sans-serif;color:' + ACC + ';margin:0;white-space:nowrap;}',
    '.ogpo__row{display:flex;align-items:center;gap:12px;padding:15px 0;' +
      'border-bottom:1px solid ' + BORDER + ';}',
    '.ogpo__row:last-child{border-bottom:0;}',
    '.ogpo__thumb{width:44px;height:44px;flex:none;border-radius:50%;object-fit:cover;' +
      'background:' + SOFT + ';}',
    '.ogpo__name{flex:1 1 auto;min-width:0;display:flex;align-items:center;gap:8px;flex-wrap:wrap;}',
    '.ogpo__main{display:flex;flex-direction:column;font:600 17px/21.25px Karla,sans-serif;color:' + INK + ';}',
    '.ogpo__sub{font:400 14px/17.5px Karla,sans-serif;color:' + MUTED + ';}',
    '.ogpo__badge{font:600 12px/17.4px Karla,sans-serif;color:' + ACC + ';background:#FBF2F5;' +
      'border-radius:999px;padding:3px 9px;white-space:nowrap;}',
    '.ogpo__step{display:flex;align-items:center;gap:10px;flex:none;}',
    '.ogpo__n{font:600 16px/1 Karla,sans-serif;color:' + INK + ';min-width:10px;text-align:center;}',
    '.ogpo__btn{width:38px;height:38px;flex:none;border:0;border-radius:50%;background:' + ACC + ';' +
      'color:#fff;display:flex;align-items:center;justify-content:center;cursor:pointer;padding:0;}',
    '.ogpo__btn[hidden]{display:none;}',
    '.ogpo__btn[disabled]{opacity:.35;cursor:default;}',
    '.product-form__submit.ogpo-wait{opacity:.55;cursor:not-allowed;}',
    '.ogpo__btn svg{width:14px;height:14px;stroke:#fff;stroke-width:2.2;fill:none;}',
    /* the source's buy column is 345px wide, so its pack cards are ~110px.
       Ours is 541px — cap the strip so the boxes come out the same size. */
    '.ogpo__tiers{display:grid;grid-template-columns:repeat(3,1fr);gap:8px;'+
      'margin:24px 0 0;}',
    '.ogpo__tier{position:relative;display:flex;flex-direction:column;gap:2px;'+
      'padding:22px 8px 14px;border:1px solid ' + BORDER + ';border-radius:12px;'+
      'background:#fff;text-align:center;cursor:pointer;font-family:Karla,sans-serif;}',
    '.ogpo__tier[aria-checked="true"]{border-color:' + ACC + ';background:#FBF2F5;}',
    '.ogpo__tier-save{position:absolute;top:-10px;left:50%;transform:translateX(-50%);'+
      'background:' + INK + ';color:#fff;font:700 11px Karla,sans-serif;letter-spacing:.22px;'+
      'padding:3px 9px;border-radius:999px;white-space:nowrap;}',
    '.ogpo__tier[aria-checked="true"] .ogpo__tier-save{background:' + ACC + ';}',
    '.ogpo__tier-name{font:600 15px Karla,sans-serif;letter-spacing:-.15px;color:' + INK + ';}',
    '.ogpo__tier-unit{font:400 13px Karla,sans-serif;color:' + MUTED + ';}',
    /* the source grows the pack type on a phone: 17px name, 14px unit */
    '@media(max-width:420px){.ogpo__title{font-size:20px;}.ogpo__main{font-size:16px;}' +
      '.ogpo__btn{width:34px;height:34px;}'+
      '.ogpo__tier-name{font-size:17px;}.ogpo__tier-unit{font-size:14px;}}'
  ].join('');

  var PLUS = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14" ' +
             'stroke-linecap="round"/></svg>';
  var MINUS = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14" ' +
              'stroke-linecap="round"/></svg>';

  function tiers() {
    return [].slice.call(document.querySelectorAll('.lumin-product-block-qty-break'))
             .filter(function (t) { return t.querySelector('.bs-form-check-input'); });
  }

  function activeTier() {
    var all = tiers(), i;
    for (i = 0; i < all.length; i++) {
      var r = all[i].querySelector('.bs-form-check-input');
      if (r && r.checked) return all[i];
    }
    return all[1] || all[0] || null;
  }

  function selectsOf(tier) {
    return tier ? [].slice.call(tier.querySelectorAll('select.lumin-form-select')) : [];
  }

  function assetBase() {
    var any = document.querySelector('link[href*="/assets/ogcore.css"], script[src*="/assets/ogcore.js"]');
    var u = any ? (any.href || any.src) : '';
    return u ? u.split('?')[0].replace(/ogcore\.(css|js)$/, '') : '/cdn/shop/t/1/assets/';
  }

  function tierInfo(t) {
    var title = t.querySelector('.lumin-product-block-qty-break-title');
    var sub = t.querySelector('.lumin-product-block-qty-break-subtitle');
    var strong = title && title.querySelector('strong');
    var em = title && title.querySelector('em');
    return {
      name: strong ? strong.textContent.trim()
                   : (selectsOf(t).length + ' stylos'),
      save: em ? em.textContent.trim() : '',
      unit: sub ? sub.textContent.trim() : ''
    };
  }

  var counts = null;
  var VID = null;   /* option value -> variant id */

  /* Lumin recomputes the tier radio's value from the selects, but only after an
     async product fetch; a quick add-to-cart would then post the previous
     combination. Keep our own map so the radio is correct immediately. */
  function loadVariants() {
    if (VID) return;
    var host = document.querySelector('[data-product-url]');
    var url = (host && host.dataset.productUrl) || location.pathname.split('?')[0];
    fetch(url + '.js').then(function (r) { return r.json(); }).then(function (p) {
      VID = {};
      (p.variants || []).forEach(function (v) { VID[v.option1 || v.title] = v.id; });
      apply();
    }).catch(function () { VID = null; });
  }

  function styleOnce() {
    if (document.getElementById('ogpo-css')) return;
    var style = document.createElement('style');
    style.id = 'ogpo-css';
    style.textContent = CSS;
    document.head.appendChild(style);
  }

  function build() {
    var all = tiers();
    if (!all.length || document.querySelector('.ogpo')) return;
    styleOnce();

    var base = assetBase();
    var box = document.createElement('div');
    box.className = 'ogpo';
    box.innerHTML =
      '<div class="ogpo__head"><h2 class="ogpo__title">Choisissez vos cellules souches</h2>' +
      '<p class="ogpo__rem" data-og="rem"></p></div>' +
      CELLS.map(function (c, i) {
        return '<div class="ogpo__row" data-i="' + i + '">' +
          '<img class="ogpo__thumb" src="' + base + c.img + '" alt="' + c.v + '" width="44" height="44" loading="lazy">' +
          '<div class="ogpo__name"><span class="ogpo__main">' + c.v +
          '<span class="ogpo__sub">' + c.sub + '</span></span>' +
          (c.badge ? '<span class="ogpo__badge">' + c.badge + '</span>' : '') + '</div>' +
          '<div class="ogpo__step">' +
          '<button type="button" class="ogpo__btn" data-d="-1" aria-label="Retirer un ' + c.v + '" hidden>' + MINUS + '</button>' +
          '<span class="ogpo__n" data-og="n" hidden>0</span>' +
          '<button type="button" class="ogpo__btn" data-d="1" aria-label="Ajouter un ' + c.v + '">' + PLUS + '</button>' +
          '</div></div>';
      }).join('');

    var strip = document.createElement('div');
    strip.className = 'ogpo__tiers';
    strip.setAttribute('role', 'radiogroup');
    strip.setAttribute('aria-label', 'Choisissez votre pack');
    strip.innerHTML = all.map(function (t, i) {
      var d = tierInfo(t);
      return '<button type="button" class="ogpo__tier" role="radio" data-t="' + i + '" aria-checked="false">' +
        (d.save ? '<span class="ogpo__tier-save">' + d.save + '</span>' : '') +
        '<span class="ogpo__tier-name">' + d.name + '</span>' +
        '<span class="ogpo__tier-unit">' + d.unit + '</span></button>';
    }).join('');
    box.appendChild(strip);

    strip.addEventListener('click', function (e) {
      var b = e.target.closest('.ogpo__tier');
      if (!b) return;
      e.preventDefault();
      var t = tiers()[+b.dataset.t];
      var lab = t && t.querySelector('.bs-form-check-label');
      if (lab) lab.click();
      else if (t) t.querySelector('.bs-form-check-input').click();
      setTimeout(reset, 0);
    });

    all[0].parentNode.insertBefore(box, all[0]);

    box.addEventListener('click', function (e) {
      var b = e.target.closest('.ogpo__btn');
      if (!b) return;
      e.preventDefault();
      var i = +b.closest('.ogpo__row').dataset.i, d = +b.dataset.d;
      var cap = selectsOf(activeTier()).length || 1;
      var sum = counts.reduce(function (a, x) { return a + x; }, 0);
      if (d > 0 && sum >= cap) return;
      if (d < 0 && counts[i] <= 0) return;
      counts[i] += d;
      apply();
    });

    document.addEventListener('change', function (e) {
      if (e.target.classList && e.target.classList.contains('bs-form-check-input')) {
        setTimeout(reset, 0);
      }
    });

    reset();
  }

  /* Nothing is pre-selected: the customer picks every pen, exactly like the
     original. Add-to-cart stays blocked until the pack is complete, so a pack
     can never be bought full of a scent nobody chose. */
  function reset() {
    counts = CELLS.map(function () { return 0; });
    apply();
  }

  function apply() {
    var tier = activeTier(), sels = selectsOf(tier), cap = sels.length || 1;
    var sum = counts.reduce(function (a, x) { return a + x; }, 0);
    if (sum > cap) { counts = CELLS.map(function () { return 0; }); sum = 0; }

    var box = document.querySelector('.ogpo');
    if (!box) return;
    box.querySelector('[data-og="rem"]').textContent =
      sum + ' sur ' + cap + (cap > 1 ? ' sélectionnées' : ' sélectionnée');
    [].slice.call(box.querySelectorAll('.ogpo__row')).forEach(function (row) {
      var i = +row.dataset.i, n = counts[i];
      row.querySelector('[data-d="-1"]').hidden = n === 0;
      var span = row.querySelector('[data-og="n"]');
      span.hidden = n === 0;
      span.textContent = n;
      row.querySelector('[data-d="1"]').disabled = sum >= cap;
    });

    var idx = tiers().indexOf(tier);
    [].slice.call(box.querySelectorAll('.ogpo__tier')).forEach(function (b) {
      b.setAttribute('aria-checked', +b.dataset.t === idx ? 'true' : 'false');
    });

    syncAtc(tier, sum, cap);

    /* write back into the hidden Lumin selects, in order */
    var queue = [];
    counts.forEach(function (n, i) { for (var k = 0; k < n; k++) queue.push(CELLS[i].v); });
    while (queue.length < cap) queue.push(CELLS[0].v);
    sels.forEach(function (s, i) {
      if (s.value === queue[i]) return;
      s.value = queue[i];
      s.dispatchEvent(new Event('change', { bubbles: true }));
    });

    var radio = tier && tier.querySelector('.bs-form-check-input');
    if (radio && VID) {
      var ids = queue.map(function (n) { return VID[n]; });
      if (ids.every(Boolean)) radio.value = ids.join(',');
    }
  }

  /* the theme prints the add-to-cart price once in Liquid and never refreshes
     it, so it kept showing the default pack's total. Mirror the selected
     tier's own total instead. */
  function tierPrice(tier) {
    var el = tier && tier.querySelector('.lumin-product-block-qty-break-total');
    if (!el) return '';
    var sp = el.querySelector('span');
    var txt = ((sp ? sp.textContent : el.textContent) || '').trim();
    var m = txt.match(/[\u20AC$\u00A3]\s?[\d.,]+|[\d.,]+\s?[\u20AC$\u00A3]/);
    return m ? m[0].trim() : '';
  }

  function syncAtc(tier, sum, cap) {
    if (!tier) return;
    var btns = [].slice.call(document.querySelectorAll('button[name="add"], .product-form__submit'));
    var span = document.querySelector('button[name="add"] > span');
    if (!span) return;
    var label = (span.dataset.ogLabel ||
                 (span.dataset.ogLabel = span.textContent.split('–')[0].trim()));
    var left = (cap || 0) - (sum || 0);

    /* pack incomplete: block the button and count down on it */
    if (left > 0) {
      btns.forEach(function (b) { b.disabled = true; b.classList.add('ogpo-wait'); });
      span.textContent = (sum === 0)
        ? (cap > 1 ? 'CHOISISSEZ VOS STYLOS' : 'CHOISISSEZ VOTRE STYLO')
        : ('CHOISISSEZ ENCORE ' + left + (left > 1 ? ' STYLOS' : ' STYLO'));
      return;
    }

    btns.forEach(function (b) { b.disabled = false; b.classList.remove('ogpo-wait'); });
    var price = tierPrice(tier);
    span.textContent = price ? (label + ' – ' + price) : label;
  }

  function boot() {
    loadVariants();
    build();
    var all = tiers();
    if (all.length > 1 && !all.some(function (t) {
      var r = t.querySelector('.bs-form-check-input'); return r && r.checked;
    })) {
      all[1].querySelector('.bs-form-check-input').click();
    }
  }

  /* Lumin re-renders the whole quantity-break block when it hydrates and on
     every variant change, which throws our panel away. Watch for that and
     put it back instead of relying on a single insertion. */
  function guard() {
    var all = tiers();
    if (!all.length) return;
    var host = all[0].parentNode;
    if (!host) return;
    if (host.dataset.ogpoWatched !== '1') {
      host.dataset.ogpoWatched = '1';
      new MutationObserver(function () {
        if (!document.querySelector('.ogpo')) boot();
      }).observe(host, { childList: true });
    }
    if (!document.querySelector('.ogpo')) boot();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
  window.addEventListener('load', boot);
  var tries = 0;
  var beat = setInterval(function () {
    guard();
    if (++tries > 40) clearInterval(beat);
  }, 400);
})();
